import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import ProjectCard from '../../../project-card';

import {
  FieldName,
  FieldValue,
  Grid,
} from '../../styles';

const buildAlphabet = (size) => {
  const alpha = Array.from(Array(size)).map((e, i) => i + 65);
  const alphabet = alpha.map((x) => String.fromCharCode(x));
  return alphabet;
};

const SurveysPagesSection = (props) => {
  const {
    values,
    smallColumn,
    editText,
    edit,
    icon,
  } = props;

  const {
    pageName,
    order,
    tasks,
    questions,
  } = values;

  const QUESTION_TYPE_RANGE = 'range';
  const QUESTION_TYPE_WRITTEN = 'written';
  const QUESTION_TYPE_SINGLE = 'single_select';
  const QUESTION_TYPE_MULTIPLE = 'multiple_select';
  const QUESTION_TYPE_URL = 'url';
  const QUESTION_TYPE_TASK = 'task';
  const QUESTION_TYPE_IMAGE = 'image_select';
  const QUESTION_TYPE_PREFERENCE = 'preference';
  const QUESTION_TYPE_FIRST_CLICK_TEST = 'first_click_test';
  const QUESTION_TYPE_RANKING = 'ranking';
  const QUESTION_TYPE_MATRIX = 'matrix';
  const QUESTION_TYPE_FIVE_SECOND = 'five_second';

  const questionTypeDict = {
    [QUESTION_TYPE_RANGE]: 'Rating',
    [QUESTION_TYPE_WRITTEN]: 'Written response',
    [QUESTION_TYPE_SINGLE]: 'Single select (pick one)',
    [QUESTION_TYPE_MULTIPLE]: 'Multi select (pick any)',
    [QUESTION_TYPE_URL]: 'URL',
    [QUESTION_TYPE_TASK]: 'Instructions',
    [QUESTION_TYPE_IMAGE]: 'Image',
    [QUESTION_TYPE_PREFERENCE]: 'Preference',
    [QUESTION_TYPE_FIRST_CLICK_TEST]: 'First click test',
    [QUESTION_TYPE_RANKING]: 'Ranking',
    [QUESTION_TYPE_MATRIX]: 'Matrix',
    [QUESTION_TYPE_FIVE_SECOND]: 'Five second test',
  };

  const getQuestionTypeTextFormatted = (questionTask) => {
    const { questionType, matrixType } = questionTask;
    const questionTypeFormatted = questionTypeDict[questionType] ?? '';
    const isMatrix = questionType === 'matrix';
    const isMatrixSingleOrMultiple = matrixType === 'single_select'
      ? `${questionTypeFormatted} (Single Select)` : `${questionTypeFormatted} (Multiple Select)`;
    const labelFormatted = isMatrix ? isMatrixSingleOrMultiple : questionTypeFormatted;
    return labelFormatted;
  };

  let surveyPageTasks = [];

  if (tasks) {
    surveyPageTasks = tasks.map((surveyPageTask) => {
      const questionTypeFormatted = getQuestionTypeTextFormatted(surveyPageTask);
      return ({
        ...surveyPageTask,
        type: surveyPageTask.questionType,
        questionType: questionTypeFormatted,
      });
    });
  } else {
    surveyPageTasks = questions.map((surveyPageTask) => {
      const questionTypeFormatted = getQuestionTypeTextFormatted(surveyPageTask);
      return ({
        ...surveyPageTask,
        type: surveyPageTask.questionType,
        questionType: questionTypeFormatted,
      });
    });
  }

  surveyPageTasks = orderBy(surveyPageTasks, ['questionOrder'], ['asc']);
  const width = smallColumn ? 4 : 6;

  return (
    <ProjectCard
      title={`Page ${order}: ${pageName}`}
      edit={edit}
      editText={editText}
      icon={icon}
    >
      <Grid>
        {surveyPageTasks && (
          surveyPageTasks.map((task, index) => {
            const {
              id,
              type,
              questionType,
              questionOptions,
              label,
            } = task;
            const alphabet = buildAlphabet(questionOptions.length);

            return (
              <Grid.Row columns={2} key={id}>
                <Grid.Column computer={width} tablet={4} mobile={8}>
                  <FieldName>{`${index + 1}. ${questionType}`}</FieldName>
                </Grid.Column>
                <Grid.Column width={10}>
                  <FieldValue>
                    {`${label} ` /** do not remove the empty space. */}
                    {(() => {
                      switch (type) {
                        case 'single_select':
                        case 'multiple_select':
                          return questionOptions.map((option, idx) => `${idx + 1}) ${option.label}`).join(' ');
                        case 'ranking':
                          return questionOptions.map((option) => option.label).join(', ');
                        case 'preference':
                          return questionOptions.map((option, idx) => `${alphabet[idx]}) ${option.label}`).join(' ');
                        default:
                          return '';
                      }
                    })()}
                  </FieldValue>
                </Grid.Column>
              </Grid.Row>
            );
          }))}
      </Grid>
    </ProjectCard>
  );
};

SurveysPagesSection.propTypes = {
  edit: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  values: PropTypes.shape({
    pageName: PropTypes.string,
    order: PropTypes.number,
    welcomeTitle: PropTypes.string,
    pageTitle: PropTypes.string,
    tasks: PropTypes.arrayOf(PropTypes.shape({})),
    questions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  smallColumn: PropTypes.bool,
  editText: PropTypes.string,
};

SurveysPagesSection.defaultProps = {
  history: {},
  smallColumn: false,
  editText: null,
};

export default SurveysPagesSection;
